module.exports = __webpack_public_path__ + "fonts/Muli-ExtraBold.36f5b43.woff";